export default __webpack_public_path__ + "static/media/heart.a1378840.png";